import styled from 'styled-components';

import { List } from 'components/list';

export const StyledList = styled(List)<{ isExpenses?: boolean }>`
  flex: 1;
  height: 100%;
  min-height: 0;
  max-height: ${({ theme }) =>
    !theme.responsive.isDesktop ? '352px' : 'unset'};
`;
